/* YO&NO — UX 3: consistent Dutch option labels (display only) */
(function(){
  var MAP={'size':'Maat','grootte':'Maat','ring grootte':'Ringmaat','maat':'Maat','lengte':'Lengte','material':'Materiaal','materiaal':'Materiaal','materiaal sieraad':'Materiaal','color':'Kleur','colour':'Kleur','kleur':'Kleur','steen':'Steen','letter':'Letter','thema':'Thema','soort':'Soort','stijl':'Stijl'};
  function fix(t){ var k=(t||'').trim().toLowerCase(); return MAP[k]||null; }
  function relabel(root){
    var r=root||document;
    r.querySelectorAll('variant-selects legend.form__label, variant-selects label.form__label, .yn-qs__on').forEach(function(el){
      var node=null; for(var i=0;i<el.childNodes.length;i++){ var c=el.childNodes[i]; if(c.nodeType===3&&c.textContent.trim()){ node=c; break; } }
      if(!node) return; var n=fix(node.textContent); if(n&&node.textContent.trim()!==n) node.textContent=node.textContent.replace(node.textContent.trim(),n);
    });
  }
  var raf=0;
  document.addEventListener('DOMContentLoaded',function(){
    relabel();
    new MutationObserver(function(){ if(!raf) raf=requestAnimationFrame(function(){ raf=0; relabel(); }); }).observe(document.body,{childList:true,subtree:true});
  });
})();
